export interface DividerWithTextProps {
    text: string
}

export const DividerWithText: React.FC<DividerWithTextProps> = (props) => {
    return (
        <div className="py-3">
            <div className="w-full h-[1px] bg-primary relative flex justify-center">
                <div className="absolute -translate-y-1/2 bg-white px-3">
                    {props.text}
                </div>
            </div>
        </div>
    )
}